import React from 'react';
import { FULCRUM_POINT_ICONS } from './types/fulcrumTypes';
import './FulcrumPoint.css';

const FulcrumPoint = ({
                          fulcrum,
                          position,
                          isSelected = false,
                          isHovered = false,
                          isMoveMode = false,
                          isDragging = false,
                          uiScale = 1,
                          onMouseEnter,
                          onMouseLeave,
                          onContextMenu,
                          onClick,
                          onDragStart
                      }) => {
    const handleMouseDown = (e) => {
        if (e.button === 0) { // ЛКМ
            e.preventDefault();
            e.stopPropagation();
            if (onDragStart) {
                onDragStart(fulcrum, e);
            }
        }
    };

    const handleClick = (e) => {
        e.stopPropagation();
        if (onClick) {
            onClick(fulcrum, e);
        }
    };

    const handleContextMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isMoveMode && (e.ctrlKey || e.metaKey)) {
            return;
        }
        if (onContextMenu) {
            onContextMenu(fulcrum, e);
        }
    };

    const pointClass = `fulcrum-point ${isSelected ? 'selected' : ''} ${isHovered ? 'hovered' : ''} ${isMoveMode ? 'move-enabled' : ''} ${isDragging ? 'dragging' : ''} ${fulcrum.type.toLowerCase()}`;

    const posX = position?.x ?? fulcrum.x;
    const posY = position?.y ?? fulcrum.y;

    return (
        <div
            className={pointClass}
            style={{
                left: `${posX}px`,
                top: `${posY}px`,
                transform: 'translate(-50%, -50%) scale(var(--point-scale, 1))',
                position: 'absolute',
                '--point-scale': uiScale
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseDown={handleMouseDown}
            onClick={handleClick}
            onContextMenu={handleContextMenu}
            title={`${fulcrum.name} (${fulcrum.type})`}
        >
            <span className="fulcrum-icon">
                {FULCRUM_POINT_ICONS[fulcrum.type] || '📍'}
            </span>
            {isHovered && (
                <div className="fulcrum-tooltip">
                    <strong>{fulcrum.name}</strong>
                    {fulcrum.description && <div>{fulcrum.description}</div>}
                </div>
            )}
        </div>
    );
};

export default FulcrumPoint;
